const state = {
    consumerTypeList: [
        {name: '拍照取证', value: 1},
        {name: '录像取证', value: 2},
        {name: '录音取证', value: 3},
        {name: '手机网页取证', value: 4},
        {name: '手机录屏取证', value: 5},
    ],
}
const mutations = {
}
const actions = {}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};